import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { IInternalCashierPaymentsProps } from '../../cashier-payments';
import { setTpaParams } from '../../redux/actions/setTpaParams';
import { configureStore } from '../../redux/createStore';
import { getInitialStoreState } from '../../redux/getInitialStoreState';
import { StoreState } from '../../types/ReduxMisc';
import { ErrorBoundary } from '../ErrorBoundary';
import { CashierPaymentsWidgetConnect } from './controller.connect';
import { guardCallbacks } from './utils/guardCallbacks';
import { validateProps } from './utils/validateProps';

export class CashierPaymentsWidgetRoot extends Component<IInternalCashierPaymentsProps> {
  private store: Store<StoreState> = configureStore(
    getInitialStoreState(this.props)
  );

  constructor(props: IInternalCashierPaymentsProps, context) {
    super(props, context);

    validateProps(props);
  }

  componentDidUpdate(prevProps) {
    const prevTpaParams = getInitialStoreState(prevProps).tpaParams;
    const currentTpaParams = getInitialStoreState(this.props).tpaParams;

    if (!isEqual(prevTpaParams, currentTpaParams)) {
      this.store.dispatch(setTpaParams(currentTpaParams));
    }
  }

  render() {
    return (
      <ErrorBoundary
        isModalTheme={this.props.theme === 'modal'}
        onCatch={guardCallbacks(this.props).onCrash}
      >
        <Provider store={this.store}>
          <CashierPaymentsWidgetConnect {...this.props} />
        </Provider>
      </ErrorBoundary>
    );
  }
}
